import styled, { keyframes } from 'styled-components'
import { gray } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'

const pulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`

// One shared placeholder primitive for every post-detail loading state,
// replacing per-component antd <Skeleton> configurations.
export const SkeletonBlock = styled.div<{
  $width: string
  $height?: string
}>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height ?? '14px'};
  background: ${gray[100]};
  border-radius: ${radii.xs}px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`

SkeletonBlock.displayName = 'SkeletonBlock'
